
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from './axios'
Vue.prototype.$http = axios


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import './../node_modules/slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';
import i18n from './plugins/i18n.js'

Vue.prototype.$http.defaults.withCredentials = true;

const app = new Vue({
	router,
	i18n,
	render: h => h(App),
})
app.$mount('#app')


